import type { FaireProductEntity } from "../../entity_types/product";

export const p_4aedre7acc: FaireProductEntity = {
  token: "p_4aedre7acc",
  type: "product",
  name: "14k Gold Dipped CZ Pave Lux Square Stud Earrings",
  brandToken: "b_c3xmn96nkh",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/28762c87da578b88a2272c714208730fc30d74b5935f7eb1660ef566230bb442.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4785e267e410a180397bcfcff92be723a166a0111ac23cab23f78befdd9e3769.jpeg",
    "https://cdn.faire.com/fastly/4f1045e7fa1f2a60c9015a1eed2cbd3ac6aa1c7eb5fe5ebd077693f257899682.jpeg",
  ],
  priceDollars: 9.54,
  description:
    'Size : 0.5" X 0.5"\r\nPost Back\r\nAdd refined sparkle to your jewelry collection with these pavé crystal cushion stud earrings featuring a soft square silhouette and shimmering stones. A timeless accessory perfect for everyday wear, formal events, or elegant styling.\nBrass\nCZ Cubic Zirconia \nGold Dipped\nHypoallergenic\nLead and Nickel Compliant\nMade In Korea\n',
  tags: [],
  msrpDollars: 19.07,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:24.045Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
